'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const applyDiffLinkedList = (before, after, list) => {
    // Delete
    if (!after && before) {
        return list.remove(before.id);
    }
    // Insert
    if (!before && after) {
        return list.insert(after);
    }
    // For the following commands, none of the 2 items can be null
    // We dont use && because checks are already done above, but ts cannot infer that they cannot be null afterwards
    if (!before || !after) {
        throw new Error('Cannot have both before & after as null');
    }
    if (before.id !== after.id) {
        throw new Error('Cannot change id of a ListNode');
    }
    const listWithPotentialReorder = before.nextId === after.nextId
        ? list
        : list
            .remove(before.id)
            .insert(after);
    return listWithPotentialReorder.update(after);
};

exports.applyDiffLinkedList = applyDiffLinkedList;
//# sourceMappingURL=apply-diff-linked-list.js.map
